import React, { useContext } from 'react';
import { PunchOutContext } from '../../contexts/PunchOutContext';

const PunchoutHidden: React.FC = ({ children }) => {
  const { punchOut } = useContext(PunchOutContext);
  if (punchOut) {
    return null;
  }
  return <>{children}</>;
};

export default PunchoutHidden;
